export const FoodInterests = [
    {
        style: { width: '9em' },
        src: require('../img/reducer.jpg'),
        altText: 'Slide 1',
        key: 1
    },
    {
        style: { width: '9em' },
        src: require('../img/proTracker.jpg'),
        altText: 'Slide 2',
        key: 2,
    },
    {
        style: { width: '9em' },
        src: require('../img/ssMenu.jpg'),
        altText: 'Slide 3',
        key: 3,
    },
    {
        style: { width: '6.5em' },
        src: require('../img/flinstone.jpg'),
        altText: 'Slide 4',
        key: 4,
    },
    {
        style: { width: '9em' },
        src: require('../img/brewing.gif'),
        altText: 'Slide 5',
        key: 5,
    },
    {
        style: { width: '6.5em' },
        src: require('../img/medium.jpg'),
        altText: 'Slide 6',
        key: 6,
    },
];
